import { AbstractFileModel } from "../abstracts";
import { FileType } from "../enums";

/**
 * * Модель с информацией о файле
 */
export class FileModel extends AbstractFileModel {
  /**Файл с устройства */
  File!: File;
  /**ID загрузки */
  UploadId!: string;
  /**Отправляется чанк */
  IsSendingChunk: boolean = false;
  /**Отправка последнего чанка */
  IsSendingLastChunk: boolean = false;
  /**Текущий загружаемый чанк */
  CurrentChunkIndex: number = 0;
  /**Тип файла */
  readonly Type: FileType = FileType.FILE;
  /**Файл является импортируемым */
  readonly IsImport: boolean = false;

  constructor(obj?: Partial<FileModel>) {
    super(obj);
    Object.assign(this, obj);
  }
}
